<template>
  <b-container class="pl-auto pr-auto text-center d-block">
    <!-- SECTION HEADER -->
    <div class="section-header">
      <h2 class="service-section-header">¿Que necesitas?</h2>
    </div>
    <b-row class="pictograms text-center">
      <b-col cols="12" sm="6" lg="3" class="px-0">
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Magnetismo')"
          style="text-decoration: none;"
        >
          <h5>Magnetismo</h5>
          <img
            src="../assets/magnetism.png"
            height="100px"
            width="100px"
            alt="Magnetismo"
            class="icono yellow-border"
          >
        </a>
      </b-col>

      <b-col cols="12" sm="6" lg="3">
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Nanotecnología')"
          style="text-decoration: none;"
        >
          <h5>Nanotecnología</h5>
          <img
            src="../assets/nano.png"
            height="100px"
            width="100px"
            alt
            class="icono orange-border"
          >
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class>
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Hardware')"
          style="text-decoration: none;"
        >
          <h5>Hardware</h5>
          <img
            src="../assets/Hardware.png"
            height="100px"
            width="100px"
            alt
            class="icono red-border"
          >
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class>
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Software')"
          style="text-decoration: none;"
        >
          <h5>Software</h5>
          <img
            src="../assets/software.png"
            height="100px"
            width="100px"
            alt
            class="icono pink-border"
          >
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class>
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Wearables')"
          style="text-decoration: none;"
        >
          <h5>Wearables</h5>
          <img
            src="../assets/wearables.png"
            height="100px"
            width="100px"
            alt
            class="icono purple-border"
          >
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class>
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('IoT')"
          style="text-decoration: none;"
        >
          <h5>IoT</h5>
          <img src="../assets/iot.png" height="100px" width="100px" alt class="icono blue-border">
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class>
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('Ciberseguridad')"
          style="text-decoration: none;"
        >
          <h5>Ciberseguridad</h5>
          <img
            src="../assets/cibersecurity.png"
            height="100px"
            width="100px"
            alt
            class="icono green-border"
          >
        </a>
      </b-col>
      <b-col cols="12" sm="6" lg="3" class="m-auto">
        <a
          href="#"
          v-scroll-to="'#test'"
          @click.prevent="goToForm('I+D')"
          style="text-decoration: none;"
        >
          <h5>I+D</h5>
          <img src="../assets/rd.png" height="100px" width="100px" alt class="icono brown-border">
        </a>
      </b-col>
    </b-row>

    <div class="contact-container">
      <div class="form-container">
        <b-container id="test" class="px-0 pb-5">
          <b-row align-h="between">
            <b-col
              cols="12"
              ms="6"
              lg="6"
              class="d-table-cell p-4 pt-5 w-100"
              style="font-weight: 900; font-weight: 900;"
            >
              <div
                class="w-100 h-100 text-left p-2"
                style="color: black;"
                v-if="selected === 'Magnetismo'"
              >
                <h2>Magnetismo</h2>

                <div class="w-100" height="6px" style="border:2px solid rgb(225, 192, 76);"></div>
                <p class="section-description">
                  Podemos ayudarte en la fabricación o caracterización de componentes magnéticos, asi como en el desarrollo de aplicaciones que contengan imanes, electroimas o requieran de medida de campos magnéticos.
                  Cuentanos tu caso, y si no podemos ayudaremos a contactar con alguien que si pueda.
                </p>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
              <div
                class="w-100 h-100 text-left p-2 d-table"
                style="color: black;"
                v-if="selected === 'Nanotecnología'"
              >
                <h2>Nanotecnología</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(238, 111, 45);"></div>
                <p
                  class="section-description"
                >En especial, la introducción de nanotecnología en productos o el desarrollo de productos que hagan uso de innovaciones provenientes del uso de nanotecnología.</p>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
              <div
                class="w-100 h-100 p-2 text-left d-table-cell"
                style="color: black;"
                v-if="selected === 'Hardware'"
              >
                <h2>Hardware</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(235, 51, 41);"></div>
                <p
                  class="section-description"
                >¿Quieres desarrollar un dispositivo? Podemos ayudarte desde el desarrollo conceptual del proyecto hasta la fabricación del producto final, pasando por la fase de prototipado.</p>
                <ul>
                  <li>Diseño conceptual</li>
                  <li>Sistemas eléctricos y electrónicos</li>
                  <li>Automatización de procesos industriales</li>
                  <li>Piezas</li>
                </ul>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
                <!-- ¡Nosotros te ayudamos! Tenemos una amplia experiencia: -->
              </div>
              <div
                class="w-100 h-100 text-left p-2"
                style="color: black;"
                v-if="selected === 'Software'"
              >
                <h2>Software</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(255, 71, 238);"></div>
                <p
                  class="section-description"
                >¿Necesitas una aplicacion movil, una pagina web o diseñar un software específico?. Desarrollamos tu software con proyectos "llave en mano" implementando metodologías actuales. También realizamos el mantenimiento.</p>
                <ul>
                  <li>Páginas Web</li>
                  <li>Tiendas Virtuales</li>
                  <li>Aplicaciones Móviles</li>
                  <li>Servidores API</li>
                  <li>Software específico</li>
                </ul>
              </div>
              <div
                class="w-100 h-100 p-2 text-left d-table-cell"
                style="color: black;"
                v-if="selected === 'Wearables'"
              >
                <h2>Wearables</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(54, 19, 131);"></div>
                <p
                  class="section-description"
                >Diseñamos y desarrollamos dispositivos wearables, tanto para el sector salud como para medicina del deporte. También podemos ofrecerte el software necesario para implementar la recogida de datos y gestión de comunicaciones de estos dispositivos.</p>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
              <div
                class="w-100 h-100 p-2 text-left d-table-cell"
                style="color: black;"
                v-if="selected === 'IoT'"
              >
                <h2>IoT</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(80, 135, 236);"></div>
                <p class="section-description">
                  Disponemos de una plataforma de IoT flexible la cual permite la gestion de diferentes dispositivos conectados a internet. Puede
                  ser usada tanto para la monitorizacion remota de procesos como para emitir instrucciones a distancia.
                  ¡Habla con nosotros si quieres saber más!
                </p>
                <ul>
                  <li>Diseño de dispositivos IoT</li>
                  <li>Monitorización remota</li>
                  <li>Automatización de procesos a través de la nube</li>
                </ul>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
              <div
                class="w-100 h-100 p-2 text-left d-table-cell"
                style="color: black;"
                v-if="selected === 'Ciberseguridad'"
              >
                <h2>Ciberseguridad</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(88, 164, 92);"></div>
                <p
                  class="section-description"
                >Manten la seguridad de tus datos y comunicaciones. Disponemos de soluciones tanto a nivel de Hardware como de Software:</p>
                <ul>
                  <li>Software de cifrado punto a punto</li>
                  <li>Cifrado de datos mediante hardware</li>
                  <li>Sistema de almacenamiento cloud encriptado</li>
                  <li>Llaves para doble verificación</li>
                </ul>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
              <div
                class="w-100 h-100 p-2 text-left d-table-cell"
                style="color: black;"
                v-if="selected === 'I+D'"
              >
                <h2>I+D</h2>
                <div class="w-100" height="6px" style="border:2px solid rgb(69, 31, 7);"></div>
                <p
                  class="section-description"
                >Participamos en proyectos de I+D, tanto en la redaccion como en su ejecucion.</p>
                <ul>
                  <li>Consultoría cientifico-técnica</li>
                  <li>Elaboración de road-maps</li>
                  <li>Tareas de investigación</li>
                  <li>Participamos en proyectos H2020</li>
                </ul>
                <h3 class="pt-4 text-center">¡Cuentanos tu caso!</h3>
              </div>
            </b-col>

            <b-col cols="12" md="6" lg="5" class="text-left px-2 mt-3">
              <div v-if="dismissCountDown !== 0">
                <b-alert
                  :show="dismissCountDown"
                  dismissible
                  variant="success"
                  @dismissed="dismissCountDown=0"
                  @dismiss-count-down="countDownChanged"
                >¡Muchas gracias por contactar con nosotros! En breve recibirá una respuesta.
                  <br>
                  Este mensaje se cerrará en {{ dismissCountDown }} segundos...
                </b-alert>
              </div>

              <div v-if="dismissCountDown === 0">
                <b-form @submit="onSubmit" id="contactForm" :show="dismissCountDown!=0">
                  <b-form-group
                    id="form-email"
                    vertical
                    :label-cols="4"
                    breakpoint="md"
                    label="Tu email:"
                    label-for="form-email"
                    label-size="sm"
                    label-class="p-0"
                  >
                    <b-form-input
                      id="inputMail"
                      v-model="formEmail"
                      name="email"
                      placeholder="Dinos un mail de contacto"
                      type="email"
                      size="sm"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="form-topic"
                    vertical
                    :label-cols="4"
                    breakpoint="md"
                    label="Asunto:"
                    label-size="sm"
                    label-class="p-0"
                    label-for="form-topic"
                  >
                    <b-form-select
                      id="topic"
                      v-model="selected"
                      :options="options"
                      name="topic"
                      class="mb-3"
                      size="sm"
                    />
                  </b-form-group>
                  <div>
                    <b-form-textarea
                      id="form-body"
                      v-model="formBody"
                      name="content"
                      placeholder="Cuentanos como podemos ayudarte"
                      :rows="12"
                      size="sm"
                    ></b-form-textarea>
                    <pre class="mt-3">{{ options.text }}</pre>
                  </div>
                  <div id="toast"></div>
                  <b-button @click="onSubmit" id="submit" variant="success" width="40%">Enviar</b-button>
                </b-form>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </b-container>
</template>

<script>
const request = require("request-promise-native");
const serverHost = process.env.SERVER_HOST || "http://localhost:8080";

// NEW receiving info
const form = document.getElementById("contactForm");
const url =
  "https://yo0eth79sc.execute-api.eu-west-1.amazonaws.com/dev/email/send";
const toast = document.getElementById("toast");
const submit = document.getElementById("submit");

function post(url, body, callback) {
  var req = new XMLHttpRequest();
  req.open("POST", url, true);
  req.setRequestHeader("Content-Type", "application/json");
  req.addEventListener("load", function() {
    if (req.status < 400) {
      console.log(`${req.status}`);
      callback(null, JSON.parse(req.responseText));
    } else {
      console.log(`${req.status}`);
      callback(new Error("Request failed: " + req.statusText));
    }
  });
  req.send(JSON.stringify(body));
}
function success() {
  console.log("success");
}
function error(err) {
  console.log(
    "There was an error with sending your message, hold up until I fix it. Thanks for waiting."
  );
  console.log(err);
}

export default {
  name: "services",
  data() {
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      selected: null,
      options: [
        { value: null, text: "Por favor, selecciona una opción" },
        { value: "Magnetismo", text: "Magnetismo" },
        { value: "Nanotecnología", text: "Nanotecnología" },
        { value: "Hardware", text: "Hardware" },
        { value: "Software", text: "Software" },
        { value: "Wearables", text: "Wearables" },
        { value: "IoT", text: "IoT" },
        { value: "Ciberseguridad", text: "Ciberseguridad" },
        { value: "I+D", text: "I+D" }
      ],
      formBody: "",
      formEmail: ""
    };
  },
  methods: {
    goToForm(newValue) {
      this.options.value = newValue;
      this.selected = newValue;
      document.getElementById("form-body").focus();
    },
    showAlert() {
      this.formBody = "";
      this.formEmail = "";
      this.dismissCountDown = this.dismissSecs;
    },
    async onSubmit() {
      console.log("Showing alert");
      this.dismissCountDown = this.dismissSecs;

      const payload = {
        name: this.selected,
        email: this.formEmail,
        content: this.formBody
      };
      post(url, payload, function(err, res) {
        if (err) {
          return error(err);
        }
        // Do something after success
        this.showAlert();
      });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    }
  }
};
</script>

<style>
/* .theContainer {
  height: 397.5px;
} */

.red-border-bottom:before {
  position: absolute;
  margin: auto;
  z-index: 1;
  content: "";
  width: 75%;
  height: 2px;
  background: #e96656;
  bottom: -9px;
  left: 12.5%;
}

.green-border-bottom:before {
  position: absolute;
  margin: auto;
  z-index: 1;
  content: "";
  width: 75%;
  height: 2px;
  background: #34d293;
  bottom: -9px;
  left: 12.5%;
}

.blue-border-bottom:before {
  position: absolute;
  margin: auto;
  z-index: 1;
  content: "";
  width: 75%;
  height: 2px;
  background: #3ab0e2;
  bottom: -9px;
  left: 12.5%;
}

.yellow-border-bottom:before {
  position: absolute;
  margin: auto;
  z-index: 1;
  content: "";
  width: 75%;
  height: 2px;
  background: #f7d861;
  bottom: -9px;
  left: 12.5%;
}

img.red-border:hover {
  border: 10px solid rgb(235, 51, 41);
}

img.red-border:not(:hover) {
  border: 10px solid black;
}

img.blue-border:hover {
  border: 10px solid rgb(80, 135, 236);
}

img.blue-border:not(:hover) {
  border: 10px solid black;
}

img.orange-border:hover {
  border: 10px solid rgb(238, 111, 45);
}

img.orange-border:not(:hover) {
  border: 10px solid black;
}

img.yellow-border:hover {
  border: 10px solid rgb(225, 192, 76);
}

img.yellow-border:not(:hover) {
  border: 10px solid black;
}

img.green-border:hover {
  border: 10px solid rgb(88, 164, 92);
}

img.green-border:not(:hover) {
  border: 10px solid black;
}

img.purple-border:hover {
  border: 10px solid rgb(54, 19, 131);
}

img.purple-border:not(:hover) {
  border: 10px solid black;
}

img.brown-border:hover {
  border: 10px solid rgb(69, 31, 7);
}

img.brown-border:not(:hover) {
  border: 10px solid black;
}

img.pink-border:hover {
  border: 10px solid rgb(255, 71, 238);
}

img.pink-border:not(:hover) {
  border: 10px solid black;
}

h5 {
  padding-top: 0px;
  color: black !important;
}

.icono {
  margin-bottom: 20px;
}

.service-section-header {
  font-weight: 800;
  font-size: 3.5em;
  padding-top: 0.1em;
  padding-bottom: 0.4em;
  color: black;
}

/* .row {
  width: 100%;
  margin-right: 0;
  margin-left: 0;
  text-align: center;
} */

.red-border-bottom:before {
  position: absolute;
  margin: auto;
  z-index: 1;
  content: "";
  width: 75%;
  height: 2px;
  background: #e96656;
  bottom: -9px;
  left: 12.5%;
}

.section-description {
  font-size: 1.2em;
  padding-top: 15px;
}

.form-group {
  margin-bottom: 1rem !important;
}
</style>
